<script>
export default {
	name: "InfoRight",
	props: {
		oss: {
			type: String,
			default: "",
		},
		value: {},
	},
	data() {
		return {
			studentProfile: [
				{field: "监护人姓名", value: "name"},
				{field: "父亲职业", value: "father_job"},
				{field: "与学生的关系", value: "relationship_name"},
				{field: "母亲职业", value: "mother_job"},
				{field: "是否为独生子女", value: "only_child"},
				{field: "监护人电话", value: "phone"},
				{field: "是否有出国经历", value: "is_chuguo"},
			],
		};
	},
};
</script>

<template>
	<div class="info-main-right">
		<div style="align-items: center;display: flex">
			<img :src="oss+'home.png'" alt="" style="width: 30.03rem;height: 27.6rem">
      <span style="width: 96rem;height: 34rem;font-weight: 600;font-size: 24rem;color: #1E3AA2;margin-left: 16rem">家庭信息</span>
		</div>
    <div class="info-wrapper">
      <div class="list-box">
        <div class="list-item" v-for="(item, index) in studentProfile" :key="index">
          <div class="label">{{ item.field }}</div>
          <div class="value">{{ value[item.value] }}</div>
        </div>
      </div>
      <div class="info-box">
        <div class="info-item">
          <div class="label"><i class="el-icon-location-information info-icon"></i>家庭住址</div>
          <div class="value">{{ value.home_address }}</div>
        </div>
        <div class="info-item">
          <div class="label"><i class="el-icon-price-tag info-icon"></i>家庭情况</div>
          <div class="value">{{ value.home_details }}</div>
        </div>
      </div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.info-main-right {
  width: 522rem;
  //height: 100%;
	background: #FFF;
	border-radius: 8rem;
	box-sizing: border-box;
	padding: 24rem;
	display: flex;
	flex-direction: column;
	margin-left: 24rem;
  .info-wrapper {
    padding-top: 110rem;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .list-box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 24rem;
  }
  .list-item {
    width: calc(50% - 12rem);
    display: flex;
    .label {
      width: 104rem;
      font-weight: 400;
      font-size: 14rem;
      color: #888888;
      flex-shrink: 0;
    }
    .value {
      font-weight: 400;
      font-size: 14rem;
      color: #3C3C3C;
    }
  }
  .info-box {
    min-height: 120rem;
    padding: 20rem;
    background-color: #F5F8FF;
    font-size: 16rem;
    border-radius: 6rem;
  }
  .info-item {
    display: flex;
    line-height: 20rem;
    &:not(:last-child) {
      margin-bottom: 20rem;
    }
    .label {
      width: 104rem;
      font-weight: 400;
      font-size: 14rem;
      color: #888888;
      flex-shrink: 0;
    }
    .value {
      font-weight: 400;
      font-size: 14rem;
      color: #3C3C3C;
    }
    .info-icon {
      color: #1C4EFD;
      font-size: 16rem;
      margin-right: 8rem;
    }
  }
}

</style>
